var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.364 31.635a8.075 8.075 0 0 1 0-11.416L20.22 4.363A8.07268458 8.07268458 0 0 1 31.636 15.78l-15.86 15.855a8.075 8.075 0 0 1-11.412 0Zm9.831-18.71 8.879 8.879 7.294-7.294a6.279 6.279 0 0 0-8.879-8.879Zm11.654 2.16a.929.929 0 0 1 .079-1.209l1.268-1.265a4.228 4.228 0 0 0 1.249-2.061 1.77 1.77 0 0 0-.614-1.744.9.9 0 1 1 1.268-1.269 3.751 3.751 0 0 1 1.11 3.33 5.833 5.833 0 0 1-1.744 3.013l-1.268 1.268a.936.936 0 0 1-1.348-.059Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/medication.31ba9303ce94a9963f715ece7b46884b.svg";
export { ForwardRef as ReactComponent };